<ion-menu side="start" type="push" contentId="main-content">
  <ion-header [translucent]="true" class="ion-no-border">
    <ion-toolbar> </ion-toolbar>
  </ion-header>

  <ion-content scroll-y="false">
    <div class="bg-surface-0 dark:bg-surface-950">
      <div class="bg-surface-0 dark:bg-surface-950 rounded-border select-none max-w-84 mx-auto">
        <ul class="list-none p-2 m-0">
          <li>
            <div
              class="flex p-2 items-center cursor-pointer gap-4 pb-6 border-b border-surface-200 dark:border-surface-800"
            >
              <img [src]="user()?.pictureUrl" class="rounded-full w-16 h-16" alt="relyon" />
              <div class="flex flex-col gap-1 flex-1">
                <span
                  class="font-medium text-base text-surface-900 dark:text-surface-0 leading-tight"
                  >{{ user()?.firstName }}</span
                >
                <p class="m-0 text-base text-surface-500 dark:text-surface-200 leading-tight">
                  {{ user()?.companyRole }}
                </p>
              </div>
            </div>

            <ul
              class="list-none p-0 m-0 overflow-hidden flex flex-col gap-1 border-t border-surface-200 dark:border-surface-800"
            >
              @for (item of menuItems(); track item.label; let i = $index) {
                <li
                  [class]="'first:pt-4 last:pb-4' + (item.className ? ' ' + item.className : '')"
                  [ngClass]="item.line ? 'border-b border-surface-200 dark:border-surface-800' : ''"
                >
                  <ion-menu-toggle>
                    @if (item.action) {
                      <!-- Action-based menu item (button) -->
                      <button
                        type="button"
                        (click)="item.action()"
                        class="group w-full bg-transparent text-left flex p-2 items-center gap-4 hover:bg-surface-50 dark:hover:bg-surface-800 border border-transparent hover:border-surface-100 dark:hover:border-surface-700 rounded-lg cursor-pointer transition-colors duration-150"
                      >
                        <div class="w-[18px] h-[18px] flex items-center justify-center">
                          <i
                            [class]="
                              item.icon +
                              ' ' +
                              getIconColorClass(item) +
                              ' group-hover:text-primary group-hover:dark:text-primary text-lg! leading-none! transition-colors duration-150'
                            "
                          ></i>
                        </div>
                        <div class="flex flex-col gap-1 flex-1">
                          <span
                            class="text-surface-500 dark:text-surface-100 font-medium text-base leading-tight"
                            >{{ item.label }}</span
                          >
                        </div>
                        @if (item.badge) {
                          <p-badge
                            [value]="item.badge"
                            [severity]="item.badgeSeverity || 'info'"
                          ></p-badge>
                        }
                      </button>
                    } @else {
                      <!-- Link-based menu item (anchor) -->
                      <a
                        [routerLink]="item.link"
                        class="group flex p-2 items-center gap-4 hover:bg-surface-50 dark:hover:bg-surface-800 border border-transparent hover:border-surface-100 dark:hover:border-surface-700 rounded-lg cursor-pointer transition-colors duration-150"
                      >
                        <div class="w-[18px] h-[18px] flex items-center justify-center">
                          <i
                            [class]="
                              item.icon +
                              ' ' +
                              getIconColorClass(item) +
                              ' group-hover:text-primary group-hover:dark:text-primary text-lg! leading-none! transition-colors duration-150'
                            "
                          ></i>
                        </div>
                        <div class="flex flex-col gap-1 flex-1">
                          <span
                            class="text-surface-500 dark:text-surface-100 font-medium text-base leading-tight"
                            >{{ item.label }}</span
                          >
                        </div>
                        @if (item.badge) {
                          <p-badge
                            [value]="item.badge"
                            [severity]="item.badgeSeverity || 'info'"
                          ></p-badge>
                        }
                      </a>
                    }
                  </ion-menu-toggle>
                </li>
              }
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </ion-content>
</ion-menu>
